import { State } from 'src/redux/reducer';
import { isLoaded, isPending, isRejected, shouldLoad } from 'src/redux/utils';

export const allMySurveySelector = (state: State) => state.allMySurvey.data;
export const allMySurveyStatusSelector = (state: State) =>
  state.allMySurvey.status;
export const allMySurveyLoadedSelector = isLoaded(allMySurveyStatusSelector);
export const shouldLoadAllListCompanySelector = shouldLoad(
  allMySurveyStatusSelector,
);
export const allMySurveyRejectedSelector = isRejected(
  allMySurveyStatusSelector,
);
export const allMySurveyPendingSelector = isPending(allMySurveyStatusSelector);
